import React from "react"
import { Link } from "react-router-dom"

export default function Footer() {
    return (
        <footer>
            <div className="footerIcons">
                <img src="logo.png" alt="logo" className="footerLogo" />
                <div className="footerSocials">
                    <div className="footerSocial">
                        <i className="fa-brands fa-instagram footerSocialIcon"></i>
                    </div>
                    <div className="footerSocial">
                        <i className="fa-brands fa-facebook-f footerSocialIcon"></i>
                    </div>
                    <div className="footerSocial">
                        <i className="fa-brands fa-pinterest-p footerSocialIcon"></i>
                    </div>
                </div>
            </div>
            <div className="footerSeperationLine"></div>
            <div className="footerInfo">
                <div className="footerPolicies">
                    <Link to="/terms">Terms & Conditions</Link>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                </div>
                <div>
                    <p className="footerCopyright">©Kai Pereira 2022 | All Rights Reserved</p>
                </div>
            </div>
        </footer>
    )
}